import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { isNative } from '@/helpers'

interface AppInfo {
  version: string
  platform: string
}

let cached: AppInfo | null = null

// Dev-only override so `yarn dev` in a browser can simulate a native app
// build without a simulator. import.meta.env.DEV is false in production
// builds regardless of what ends up in .env, so this can't leak.
const fakeVersion = import.meta.env.VITE_FAKE_APP_VERSION
const fakePlatform = import.meta.env.VITE_FAKE_APP_PLATFORM

export async function init() {
  if (import.meta.env.DEV && fakeVersion && fakePlatform) {
    cached = { version: fakeVersion, platform: fakePlatform }
    return
  }

  if (!isNative) return

  try {
    const info = await CapacitorApp.getInfo()
    cached = { version: info.version, platform: Capacitor.getPlatform() }
  } catch (error) {
    console.error('Failed to read app info', error)
  }
}

export function getAppInfo(): AppInfo | null {
  return cached
}
